import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  AsyncValidatorFn,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { PodrucjePrijave, Prijavnica, Zupanije } from '../post.model';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ValidationErrors } from '@angular/forms';
import { PostsService } from '../modules/core/services/posts.service';
import { __values } from 'tslib';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  Observable,
  of,
  Subject,
  switchMap,
  take,
  takeUntil,
  tap,
  timer,
} from 'rxjs';
import { animate, style, transition, trigger } from '@angular/animations';
import { BankService } from '../bank.service';
import { Natjecaj, PrijavnicaDokument } from '../model';

// --- NOVO: helper za parsiranje "0.000,00" u number
function parseHrNumber(v: any): number | null {
  if (v == null) return null;
  if (typeof v === 'number') return v;
  const s = String(v).trim();
  if (!s) return null;
  const n = Number(s.replace(/\./g, '').replace(',', '.'));
  return isNaN(n) ? null : n;
}

export const noHtmlInFormValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {

  if (!control || !control.value) {
    return null;
  }

  const htmlRegex = /<[^>]*>/g;

  const hasHtml = Object.values(control.value)
    .some(value =>
      typeof value === 'string' && htmlRegex.test(value)
    );

  return hasHtml ? { htmlNotAllowed: true } : null;
};

// --- NOVO: validator koji osigurava projektIznos >= projektIznosHep
export function ukupnoNeManjeOdHepValidator(
  ukupnoKey: string = 'projektIznos',
  hepKey: string = 'projektIznosHep',
): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const ukupno = parseHrNumber(group.get(ukupnoKey)?.value);
    const hep = parseHrNumber(group.get(hepKey)?.value);
    if (ukupno == null || hep == null) return null; // ne blokiraj dok oba nisu unesena

    if (ukupno >= hep) {
      // počisti group error ako je bio postavljen ranije
      if (group.errors?.['ukupnoManjeOdHep']) {
        const { ukupnoManjeOdHep, ...rest } = group.errors!;
        return Object.keys(rest).length ? rest : null;
      }
      return null;
    }

    // postavi group error
    return { ...(group.errors || {}), ukupnoManjeOdHep: true };
  };
}

export function customNumberValidator(min: number, max: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    // if (!control.value) return null;

    // // Zamijenite točke i zarez
    // const cleanedValue = control.value.replace(/\./g, '').replace(',', '.');

    // const numericValue = parseFloat(cleanedValue);
    // Definicija patterna
    //  const pattern = /^\d{1,3}(\.\d{3})*(\,\d{2})?$/;
    const value = control.value;

    // Ako polje nije ispunjeno, vratite null (validno za prazno polje ako nije required)
    if (!value) return null;

    // Uklanjanje nepotrebnih razmaka sa početka i kraja
    const trimmedValue = value.trim();

    // Definicija patterna
    const pattern = /^\d{1,3}(\.\d{3})*(\,\d{2})?$/;

    // Pretvaranje u broj nakon uklanjanja točaka i zamjene zareza s točkom
    const numericValue = parseFloat(
      trimmedValue.replace(/\./g, '').replace(',', '.'),
    );

    // Provjera: vrijednost nije broj ili ne zadovoljava pattern
    if (isNaN(numericValue) || !pattern.test(trimmedValue)) {
      return { invalidFormat: true }; // Ako vrijednost nije broj
    }

    if (numericValue < min) {
      return { min: { value: numericValue, required: min } };
    }

    if (numericValue > max) {
      return { max: { value: numericValue, required: max } };
    }

    return null; // Vrijednost je valjana
  };
}

export class TimerDemoComponent {
  showElement = false;

  constructor() {
    this.delayShow();
  }

  delayShow() {
    setTimeout(() => {
      this.showElement = true;
    }, 3000); // 3 sekunde kašnjenja
  }
}
@Component({
  standalone: false,
  selector: 'app-apply',
  templateUrl: './apply.component.html',
  styleUrls: ['./apply.component.scss'],
  animations: [
    trigger('flyInOut', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(100%)' }), // Početna pozicija
        animate(
          '0.05s ease-out',
          style({ opacity: 1, transform: 'translateX(0)' }),
        ), // Kraj
      ]),
      // transition(':leave', [
      //   animate('0.3s ease-in', style({ opacity: 0, transform: 'translateX(-100%)' })) // Izlaz
      // ]
      // )
    ]),
  ],
})
export class ApplyComponent implements OnInit, OnDestroy {
  // generatedCaptcha: string = '';
  // captchaTouched = false; // dodatna zaštita

  captchaText: string = '';
  userInput: string = '';
  isCaptchaValid = false;
  captchaError = false;
  private destroy$ = new Subject<void>();
  prijavnicaForm!: FormGroup;
  prijavnicaFormFile!: FormGroup;
  novaPrijavnica: Prijavnica[] = [];
  name!: string;
  emailUser!: string;
  show: boolean = true;
  steps: number[] = [1, 2, 3, 4, 5];
  currentStep: number = 1; // Kontrolira koji dio forme je prikazan
  hover1: boolean = false;
  hover2: boolean = false;
  hover3: boolean = false;
  hover4: boolean = false;
  hover5: boolean = false;
  hover6: boolean = false;
  hover7: boolean = false;
  // selectedFile: File | null = null;
  // selectedFileR: File | null = null;
  // selectedFileO: File | null = null;
  // selectedFileN: File | null = null;
  selectedFile1: File | null = null;
  selectedFile2: File | null = null;
  selectedFile3: File | null = null;
  selectedFile4: File | null = null;
  selectedFile5: File | null = null;
  selectedFile6: File | null = null;
  selectedFile7: File | null = null;
  showModal: boolean = false;
  http!: HttpClient;
  godine!: string;
  podrucjaPrijave: PodrucjePrijave[] = [];
  zupanije: Zupanije[] = [];
  selectedPodrucjeId: number | null = null; // ID odabranog područja
  selectedZupanijaId: number | null = null;
  selectedZupanija!: string;
  natjecaj?: Natjecaj;

  private gradRucnoUpisan = false;

  isLoadingGrad = false; // Nova varijabla za loading indikator
  isLoadingOib = false;
  showInfo = false;
  @ViewChild('mymodal') modalTemplate!: TemplateRef<any>;
  @ViewChild('modal', { static: false }) modal!: ElementRef;
  @ViewChild('fileInput1') fileInput1!: ElementRef<HTMLInputElement>;
  @ViewChild('fileInput2') fileInput2!: ElementRef<HTMLInputElement>;
  @ViewChild('fileInput3') fileInput3!: ElementRef<HTMLInputElement>;
  @ViewChild('fileInput4') fileInput4!: ElementRef<HTMLInputElement>;
  @ViewChild('fileInput5') fileInput5!: ElementRef<HTMLInputElement>;
  @ViewChild('fileInput6') fileInput6!: ElementRef<HTMLInputElement>;
  @ViewChild('fileInput7') fileInput7!: ElementRef<HTMLInputElement>;

  //BROJAČI ZNAKOVA  U PRIJAVNICI
  remainingCharacters: number = 200; //brojač za naziv 200 znakova
  projectCurrentCharacterCount: number = 0;
  projektRezultatiCurrentCharacterCount: number = 0;
  projektOpisCurrentCharacterCount: number = 0;
  projektProblemCurrentCharacterCount: number = 0;
  projektKorisniciCurrentCharacterCount: number = 0;
  projektCiljCurrentCharacterCount: number = 0;
  projektOdgOsCurrentCharacterCount: number = 0;
  projektAktivnostiCurrentCharacterCount: number = 0;
  projektPracenjeCurrentCharacterCount: number = 0;

  constructor(
    private fb: FormBuilder,
    public postsService: PostsService,
    private route: ActivatedRoute,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private bankService: BankService,
  ) {
    this.generateCaptcha();
    //   this.prijavnicaForm = this.fb.group({
    //   predlagNaziv: ['', [Validators.required, Validators.maxLength(200)]],
    //   projektNaziv: ['', [Validators.required, Validators.maxLength(200)]],
    //   projektRezultati: ['', [Validators.required, Validators.maxLength(2000)]],
    //   projektOpis: ['', [Validators.required, Validators.maxLength(2000)]],
    //   projektKorisnici: ['', [Validators.required, Validators.maxLength(2000)]],
    //   projektCilj: ['', [Validators.required, Validators.maxLength(2000)]],
    //   projektOdgOs: ['', [Validators.required, Validators.maxLength(200)]],
    //   projektPracenje: ['', [Validators.required, Validators.maxLength(2000)]],
    // });
  }

  //min i max iznos za natječaj

  formattedValue: string = '';
  // za timer:
  expires: string = '';
  timeRemaining: string = '';
  // endTime!: number; // Vrijeme kada link ističe

  //pomicanje timera:
  position = { x: 0, y: 0 }; // Početna pozicija
  private isDragging = false;
  private startOffset = { x: 0, y: 0 };

  updateProjektPracenjeCharacterCount() {
    this.projektPracenjeCurrentCharacterCount =
      this.prijavnicaForm.get('projektPracenje')?.value.length || 0;
  }
  updateProjektAktivnostiCharacterCount() {
    this.projektAktivnostiCurrentCharacterCount =
      this.prijavnicaForm.get('projektAktivnosti')?.value.length || 0;
  }

  updateProjektOdgOsCharacterCount() {
    this.projektOdgOsCurrentCharacterCount =
      this.prijavnicaForm.get('projektOdgOs')?.value.length || 0;
  }
  updateProjektCiljCharacterCount() {
    this.projektCiljCurrentCharacterCount =
      this.prijavnicaForm.get('projektCilj')?.value.length || 0;
  }

  updateProjektKorisniciCharacterCount() {
    this.projektKorisniciCurrentCharacterCount =
      this.prijavnicaForm.get('projektKorisnici')?.value.length || 0;
  }
  updateProjektOpisCharacterCount() {
    this.projektOpisCurrentCharacterCount =
      this.prijavnicaForm.get('projektOpis')?.value.length || 0;
  }
  updateProjektProblemCharacterCount() {
    this.projektProblemCurrentCharacterCount =
      this.prijavnicaForm.get('projektProblem')?.value.length || 0;
  }
  // Funkcija koja ažurira broj karaktera za 'projektRezultati'
  updateProjektRezultatiCharacterCount() {
    this.projektRezultatiCurrentCharacterCount =
      this.prijavnicaForm.get('projektRezultati')?.value.length || 0;
  }
  updateProjectCharacterCount() {
    this.projectCurrentCharacterCount =
      this.prijavnicaForm.get('projektNaziv')?.value.length || 0;
  }
  // Funkcija koja se poziva svaki put kad korisnik unese tekst
  updateCharacterCount() {
    const inputLength =
      this.prijavnicaForm.get('predlagNaziv')?.value.length || 0;
    this.remainingCharacters = 200 - inputLength;
  }

  onMouseDown(event: MouseEvent): void {
    this.isDragging = true;
    this.startOffset = {
      x: event.clientX - this.position.x,
      y: event.clientY - this.position.y,
    };

    document.addEventListener('mousemove', this.onMouseMove.bind(this));
    document.addEventListener('mouseup', this.onMouseUp.bind(this));
  }

  onMouseMove(event: MouseEvent): void {
    if (this.isDragging) {
      this.position.x = event.clientX - this.startOffset.x;
      this.position.y = event.clientY - this.startOffset.y;
    }
  }

  onMouseUp(): void {
    this.isDragging = false;
    document.removeEventListener('mousemove', this.onMouseMove.bind(this));
    document.removeEventListener('mouseup', this.onMouseUp.bind(this));
  }

  trainMenuOpen = false;

  toggleTrainMenu() {
    this.trainMenuOpen = !this.trainMenuOpen;
  }

  onZupanijaChange(zupId: number | string) {
    const id = Number(zupId);
    this.selectedZupanijaId = id;
    this.selectedZupanija = this.getZupanijaNaziv(id);
  
  }

  getZupanijaNaziv(id: number | string): string {
    const numericId = Number(id);

    const zupanija = this.zupanije.find((p) => p.id === numericId);
    return zupanija?.naziv ?? '';
  }

  validateOib(control: AbstractControl): ValidationErrors | null {
    const oib = control.value;
    return oib && oib.length !== 11 ? { invalidOib: true } : null;
  }

  oibError: string = '';

  onIbanChange(): void {
    const iban = this.prijavnicaForm.get('predlagIban')?.value;
    const banka = this.bankService.prepoznajBanku(iban);
    this.prijavnicaForm.get('predlagBanka')?.setValue(banka);
  }

  oibExistsValidator(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      if (!control.value || control.value.length !== 11) {
        this.isLoadingOib = false;
        return of(null);
      }

      return this.postsService.getExistsOib(control.value).pipe(
        tap((response) => {
          this.oibError = response.message; // Postavljanje poruke u oibError
          this.isLoadingOib = false;
          //   console.log("📢 API response:", response);
        }),
        map((response) =>
          response.status === 'EXISTS' ? { oibExists: true } : null,
        ),

        catchError((error) => {
          this.isLoadingOib = false;
          console.error('Greška u validaciji OIB-a:', error);
          if (error.status === 409) {
            return of({ oibExists: true }); // Ako je 409, postavi grešku
          }
          this.isLoadingOib = false;
          return of(null); // Ako je neka druga greška, ne blokiraj validaciju
        }),
      );
    };
  }

  loadPodrucja = false;
  loadPodrucjePrijave(): void {
    this.postsService
      .getPodrucjePrijave()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          this.podrucjaPrijave = response;
          this.loadPodrucja = true;
        },
        error: (error) => {
          console.error('Došlo je do greške:', error);
          this.loadPodrucja = false;
        },
        complete: () => {
          this.loadPodrucja = true;
        },
      });
  }
  onSelect(id: number): void {
    this.selectedPodrucjeId = id;
    this.postsService.podrucjeNaziv = this.getNazivPodrucja(id);
    this.prijavnicaForm.patchValue({
      idPodr: this.selectedPodrucjeId,
      nazivPodr: this.postsService.podrucjeNaziv,
    });
  }

  getNazivPodrucja(idPodr: number): string {
    const podrucje = this.podrucjaPrijave.find((p) => p.idPodr === idPodr);
    return podrucje ? podrucje.kategorija : '';
  }

  setAll() {
    this.prijavnicaForm.patchValue({
      idPodr: 1,
      predlagNaziv: 'Škola za primijenjenu umjetnost u Rijeci',
      predlagOib: '11784884588',
      predlagMatReg: 'Registar 1',
      predlagUlica: 'ŠETALIŠTE TRINAESTE DIVIZIJE 75',
      predlagGrad: 'RIJEKA',
      predlagZupanijaId: 21,
      predlagZupanija: 'Zagrebačka',
      predlagPtBr: '51000',
      //  predlagEmail: 'Ivana@hep.hr',
      predlagIban: 'HR1234567891011121314',
      predlagBanka: 'PBZ',
      predlagOvlOs: 'Ja',
      predlagFjaOvlOs: 'Direktor',
      predlagTel: '0992623531',
      predlagGodOsnut: '1981',
      predlagBrOsobaNak: 1,
      predlagBrVolonteri: 1,
      predlagBrZaposleni: 1,
      predlagPrihodi: '1.000,00',
      predlagBrDonacija: '1',
      predlagGodDonacija: 2022,
      predlagCiljOsnivanja: 'Cilj',
      projektOpis: 'Opis',
      projektNaziv: 'Naziv',
      projektCilj: 'Da nam svima bude bolje',
      projektGeoPodr: 'Njiva i okolica',
      projektSredstva: 'Neki izvor',
      projektIznosHep: '3.900,00',
      projektIznos: '3.900,00',
      projektProblem: 'Bilo je problema',
      projektRezultati: 'Za nas nula',
      projektAktivnosti: 'Svašta pomalo, najviše pojist popit',
      projektKorisnici: 'Vole svi koristit',
      projektPracenje: 'Slabo pratim',
      projektOdgOs: 'Direktor',
      predlagodgNaziv: 'Za odgovor je potrebno dvoje',
      predlagodgAdresa: 'Gulaš bez mesa',
      predlagodgPtBr: '10000',
      predlagodgTel: '000',
      predlagodgGrad: 'Cipelgrad',
      predlagodgKontaktOs: 'Osoba Zvana Ana',
      predlagodgEmail: 'TestniMail@hep.hr',
    });
  }

  formattedProjektIznosHep: string = ''; // Početna vrijednost za prvo polje
  formattedPredlagPrihodi: string = '';
  formattedProjektIznos: string = ''; // Početna vrijednost za drugo polje

  onStepClick1(step: number) {
    this.currentStep = step; //this.nextStepValidate(step)
  }

  onStepClick(step: number) {
    if (step > this.currentStep) {
      const validStep = this.nextStepValidate(step);

      if (validStep === step) {
        this.currentStep = step; // Dozvoli prelazak ako je validno
      } else {
        this.currentStep = validStep;
      }
    } else {
      // Omogući vraćanje na prethodne korake bez validacije
      this.currentStep = step;
    }
  }

  nextStepValidate(step: number): number {
    let stepCheck = 1;

    while (stepCheck < step) {
      if (this.validirajStep(stepCheck)) {
        //   console.log(`Korak ${stepCheck} je validan.`);
        stepCheck++;
      } else {
        return stepCheck; // Ako nije validan, vrati taj korak
      }
    }

    return step; // Ako su svi prethodni koraci validni, dozvoli prelazak
  }

  // Funkcija za automatsko formatiranje unosa
  onInputChangeFields(value: string, field: string): void {
    value = value.replace(/\D/g, ''); // Ukloni sve neželjene znakove (samo brojevi)
    //      value = value.replace(/^0+/, ''); // Uklanja sve vodeće nule
    //ovo je izmjena ako hoćemo da se može nula upisivati a iznad je ako ne
    value = value.replace(/^0+(?!$)/, '');

    if (!value) {
      this.prijavnicaForm.get(field)?.setValue('', { emitEvent: false }); // Ako je unos prazan, postavi praznu vrijednost
      return;
    }

    let formattedValue = value.slice(0, -2) + ',' + value.slice(-2);

    // if (formattedValue.length < 2) {
    //   formattedValue = '0,' + formattedValue.padStart(1, '0');
    // }
    if (formattedValue.length < 4) {
      formattedValue = formattedValue.padEnd(2, '0');
    }
    formattedValue = formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    this.prijavnicaForm
      .get(field)
      ?.setValue(formattedValue, { emitEvent: false });
    //popraviti!!!
    if (value.length == 1) {
      formattedValue = '00,0' + value;
      this.prijavnicaForm
        .get(field)
        ?.setValue(formattedValue, { emitEvent: false });
      return;
    }
    if (value.length == 2) {
      formattedValue = '00,' + value;
      this.prijavnicaForm
        .get(field)
        ?.setValue(formattedValue, { emitEvent: false });
      return;
    }
    //this[field] = formattedValue; // Ažuriraj odgovarajući field

    //  this.prijavnicaForm.patchValue({ field: formattedValue });
  }
  // Custom validator za validaciju iznosa

  validateIznosHep(minIznos: number, maxIznos: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null; // prazno -> ne validiraj ovdje

      const value = control.value.replace(/\./g, '').replace(',', '.'); // "0.000,00" -> "0000.00"
      const numValue = parseFloat(value);
    

      if (isNaN(numValue)) {
        return { invalidFormat: true };
      }
      if (numValue > maxIznos*1) {
        return { max: true };
      }
      if (numValue < minIznos*1) {
        return { min: true };
      }
      return null;
    };
  }
  generateCaptcha() {
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < 6; i++) {
      result += characters.charAt(
        Math.floor(Math.random() * characters.length),
      );
    }
    this.captchaText = result;
    this.userInput = ''; // Resetiraj unos korisnika
    this.isCaptchaValid = false; // Resetiraj status provjere
    this.captchaError = false;
    this.emptyCaptchaError = false;
    // this.cdr.detectChanges();
  }
  disableCopyPaste(event: ClipboardEvent): void {
    event.preventDefault();
  }
  verifyCaptcha() {
    this.isCaptchaValid = this.userInput === this.captchaText;
    this.captchaError = false;
    this.emptyCaptchaError = false;
    this.cdr.detectChanges();
  }

  isLoadingZupanija = false;
  loadZupanija(): void {
    this.postsService
      .getZupanije()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          this.zupanije = response;
          this.isLoadingZupanija = false;
        },
        error: (error) => {
          console.error('Došlo je do greške:', error);
          this.isLoadingZupanija = false;
        },
        complete: () => {
          this.isLoadingZupanija = true;
        },
      });
  }

  ngOnInit(): void {
    //     console.log(this.route.snapshot.queryParamMap.get('email')!)
    // Postavi početnu poziciju u donji desni kut na temelju veličine prozora
    this.position.x = window.innerWidth - window.innerWidth * 0.2; // Širina elementa (300px) se oduzima1600;//
    this.position.y = 635; //window.innerHeight - 90; // Visina elementa (70px) se oduzima
    //razmisliti je li ok jer nestane kad se smanji ekran
    const trajanjeMin = this.postsService.natjecaj?.trajanjeTokenaMin ?? 0;
    // Kreiraj formu s više polja
    this.loadZupanija();
    this.emailUser = this.route.snapshot.queryParamMap.get('email')!;
    this.loadPodrucjePrijave();
    //this.dohvatiAktivanNatjecaj();
    const token = this.route.snapshot.paramMap.get('token')!;
    if (token) {
     
      this.postsService.validateToken(token).subscribe({
        next: (response) => {
          this.postsService.email = response.data.email!;
          this.emailUser = this.postsService.email;
          this.expires = response.data.message!;
          this.postsService.expires = this.expires;

          this.prijavnicaForm = this.fb.group(
            {
              // Prva stranica unosa (korisnički podaci)
              idPodr: ['', Validators.required],
              nazivPodr: [''],
              predlagNaziv: ['', Validators.required],
              predlagOib: [
                '',
                [
                  Validators.required,
                  Validators.pattern(/^\d{11}$/),
                  this.validateOib.bind(this),
                ],
                [this.oibExistsValidator().bind(this)],
              ],
              predlagMatReg: ['', Validators.required],
              predlagUlica: ['', Validators.required],
              predlagGrad: ['', Validators.required],
              predlagZupanijaId: ['', Validators.required],
              predlagZupanija: [''],
              predlagPtBr: [
                '',
                [
                  Validators.required,
                  Validators.pattern(/^\d+$/),
                  Validators.min(10000),
                ],
              ],
              predlagEmail: [
                this.emailUser,
                [Validators.required, Validators.email],
              ],
              predlagIban: [
                '',
                [Validators.required, Validators.pattern(/^HR\d{19}$/)],
              ], //  [''],// Validators.required],
              predlagModel: [''],
              predlagPnb: [''],
              predlagBanka: ['', Validators.required],
              predlagOvlOs: ['', Validators.required],
              predlagFjaOvlOs: ['', Validators.required],
              predlagTel: ['', Validators.required],
              //  predlagTelefaks:  [''],// Validators.required],
              // predlagGodOsnut:['',  Validators.pattern("^[0-9]+$")],// [''],// Validators.required],
              predlagGodOsnut: [
                '',
                [
                  Validators.required,
                  Validators.pattern(/^\d+$/),
                  Validators.min(1900),
                  Validators.max(new Date().getFullYear()),
                ],
              ],
              predlagBrOsobaNak: [
                '',
                [Validators.required, Validators.pattern('^[0-9]*$')],
              ], // Validators.required],
              predlagBrVolonteri: [
                '',
                [Validators.required, Validators.pattern('^[0-9]*$')],
              ], // Validators.required],
              predlagBrZaposleni: [
                '',
                [Validators.required, Validators.pattern('^[0-9]*$')],
              ], // Validators.required],
              predlagPrihodi: [
                '',
                [
                  Validators.required,
                  Validators.pattern(
                    //  /^((0)|(\d{1,3}(\.\d{3}){0,3}))\,\d{2}$/
                    /^\d{1,3}(\.\d{3})*(\.\d{3})*(\.\d{3})*(\,\d{2})$/,
                  ),
                ],
              ], // [''],// Validators.required],
              //      Validators.pattern(/^0|(?:\d{1,3}(\.\d{3})*(\,\d{2})?)$/)
              //  Validators.pattern(/^\d{1,3}(\.\d{3})*(\,\d{2})?$/)
              predlagBrDonacija: [
                '',
                [Validators.required, Validators.pattern('^[0-9]*$')],
              ], // Validators.required],
              predlagGodDonacija: [
                '',
                [Validators.required, Validators.pattern('^[0-9]*$')],
              ], // Validators.required],
              predlagCiljOsnivanja: ['', Validators.required],

              // Druga stranica unosa (podaci o projektu)
              projektNaziv: ['', Validators.required],
              projektOpis: ['', Validators.required],
              projektIznos: [
                '',
                [
                  Validators.required,
                  Validators.pattern(
                    /^\d{1,3}(\.\d{3})*(\.\d{3})*(\.\d{3})*(\,\d{2})$/,
                  ),
                ],
              ],
              projektCilj: ['', Validators.required],
              projektGeoPodr: ['', Validators.required],
              projektSredstva: ['', Validators.required],
              projektIznosHep: [
                '',
                [
                  Validators.required,
                  Validators.pattern(/^\d{1,3}(\.\d{3})*(,\d{2})?$/),
                  this.validateIznosHep(
                    this.postsService.natjecaj.minIznos*1,
                    this.postsService.natjecaj.maxIznos*1,
                  ),
                ],
              ],
              projektProblem: ['', Validators.required],
              projektRezultati: ['', Validators.required],
              projektAktivnosti: ['', Validators.required],
              projektKorisnici: ['', Validators.required],
              projektPracenje: ['', Validators.required],
              projektOdgOs: ['', Validators.required],
              predlagodgNaziv: ['', Validators.required],

              predlagodgAdresa: ['', Validators.required],
              predlagodgPtBr: [
                '',
                [
                  Validators.required,
                  Validators.pattern(/^\d+$/),
                  Validators.min(10000),
                ],
              ],
              predlagodgTel: ['', Validators.required],
              predlagodgGrad: ['', Validators.required],
              predlagodgKontaktOs: ['', Validators.required],
              predlagodgEmail: ['', [Validators.required, Validators.email]],
              godinaPrijave: [''],
              idNatjecaja: [''],
              nazivNatjecaja: [''],
              godinaNatjecaja: [''],
              token: [token],
              // captchaInput: ['', Validators.required]
            },
            {
              // --- NOVO: cross-field validacija ukupno >= hep
              validators: [
                ukupnoNeManjeOdHepValidator('projektIznos', 'projektIznosHep'),    noHtmlInFormValidator 
              ],
            },
          );

          // ovo za ptbr:
          this.prijavnicaForm
            .get('predlagPtBr')
            ?.valueChanges.pipe(
              // Filtriraj samo valjane dužine i ako nije prazan
              filter(
                (ptbr) => ptbr && ptbr.length === 5 && /^[0-9]{5}$/.test(ptbr),
              ),
              // Debounce da ne šalješ request na svaku znamenku
              debounceTime(500),
              // Ako je korisnik već ručno mijenjao grad, preskoči dohvat
              // (ali dozvoli ponovni dohvat ako obriše grad i ponovo upiše isti PTBR)
              distinctUntilChanged(),
            )
            .subscribe((ptbr) => {
              this.dohvatiGradPoPtbr(ptbr);
            });

          // kad korisnik RUČNO mijenja polje grad
          this.prijavnicaForm
            .get('predlagGrad')
            ?.valueChanges.subscribe((value) => {
              // Ako je korisnik nešto upisao ili obrisao, označi kao ručno
              if (this.prijavnicaForm.get('predlagGrad')?.dirty) {
                this.gradRucnoUpisan = true;
              }

              // Ako je polje prazno, dozvoli ponovni automatski dohvat sljedeći put
              if (!value || value.trim() === '') {
                this.gradRucnoUpisan = false;
              }
            });

          ////////////
          this.prijavnicaFormFile = this.fb.group({
            obrazacProracuna: [null, Validators.required],
            dokazRegistarNadl: [null, [Validators.required]],
              potvrdaPorezna: [null, [Validators.required]],
                uvjerenjeNekaz: [null, [Validators.required]],
                  izjavaOsnova: [null, [Validators.required]],
            dokazRegistarNeprofit: [null],
            dokumentiOstalo: [null],
          });
          // 🔁 Pretplata na valueChanges za automatsku konverziju u velika slova
          this.prijavnicaForm
            .get('predlagIban')!
            .valueChanges.subscribe((value) => {
              if (value && value !== value.toUpperCase()) {
                this.prijavnicaForm
                  .get('predlagIban')!
                  .setValue(value.toUpperCase(), {
                    emitEvent: false,
                  });
              }
            });

         
           //this.setAll(); // odkomentiraj ako želiš da ti se sve automatski popuni

          this.prijavnicaForm.patchValue({
            godinaPrijave: this.postsService.natjecaj.godina,
          });
          this.prijavnicaForm.patchValue({
            idNatjecaja: this.postsService.natjecaj.idNatjecaja,
            nazivNatjecaja: this.postsService.natjecaj.naziv,
            godinaNatjecaja: this.postsService.natjecaj.godina,
          });
          this.updateTimeRemaining();
          setInterval(() => this.updateTimeRemaining(), 1000); // Ažuriraj svake sekunde

          this.prijavnicaForm
            .get('predlagZupanijaId')
            ?.valueChanges.subscribe((id: number) => {
              this.onZupanijaChange(id);
            });
        },

        error: (err) => {
          this.show = false;
          console.error(err.message); // Za greške
          this.router.navigate(['/error']);
        },
      });
    } else {
      this.router.navigate(['/error']); // Ako nema tokena
    }

    //kraj onInit-a
  }
onZupanijaSelect(event: Event): void {
  const selectedId = Number((event.target as HTMLSelectElement).value);

  const selectedZupanija = this.zupanije.find(
    z => z.id === selectedId
  );

  if (!selectedZupanija) {
    return;
  }

  this.prijavnicaForm.patchValue({
    predlagZupanijaId: selectedZupanija.id,
    predlagZupanija: selectedZupanija.naziv
  });
}

  //ovo za ptbr;
  dohvatiGradPoPtbr(ptbr: string) {
    this.isLoadingGrad = true; // Počni loading
    this.postsService.dohvatiPoPtbr(ptbr).subscribe({
      next: (podatak) => {
        if (!podatak || !podatak.naziv) {
          // Ako nema podatka, ne diraj polje (korisnik može ručno upisati)
          return;
        }

        const gradControl = this.prijavnicaForm.get('predlagGrad');

        // Popuni grad SAMO AKO korisnik nije već ručno nešto upisao
        if (!this.gradRucnoUpisan) {
          gradControl?.setValue(podatak.naziv, { emitEvent: false });
          // Opcionalno: resetiraj dirty flag ako želiš čisto stanje
          gradControl?.markAsPristine();
        }
        this.isLoadingGrad = false;
        // Ako je this.gradRucnoUpisan = true → ne diramo, korisnik je već ručno promijenio
      },
      error: (err) => {
        console.error('Greška pri dohvatu grada po PTBR:', err);
        this.isLoadingGrad = false;
        // Ne radimo ništa – korisnik može ručno upisati
      },
    });
  }

  // Opcionalno: ako želiš omogućiti ponovni automatski dohvat ako korisnik obriše grad
  // (npr. obriše automatski popunjeni grad → sljedeći put kad upiše PTBR opet dohvati)
  resetGradRucnoUpisan() {
    const gradControl = this.prijavnicaForm.get('predlagGrad');
    if (!gradControl?.value || gradControl.value.trim() === '') {
      this.gradRucnoUpisan = false;
    }
  }

  //////////
  updateTimeRemaining(): void {
    const targetDate = new Date(this.expires);
    const now = new Date();
    const diffMs = targetDate.getTime() - now.getTime(); // Razlika u milisekundama

    if (diffMs > 0) {
      // const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

      this.timeRemaining = ` ${hours}h ${minutes}m ${seconds}s`;
    } else {
      this.timeRemaining = 'Vrijeme je isteklo!';
      this.postsService.tokenStatus = 'EXPIRED';

      this.router.navigate(['/error']);
    }
  }

  formatTime(milliseconds: number): string {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const hours = Math.floor(totalSeconds / 3600)
      .toString()
      .padStart(2, '0');
    const minutes = Math.floor((totalSeconds % 3600) / 60)
      .toString()
      .padStart(2, '0');
    const seconds = (totalSeconds % 60).toString().padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  }

  onOibChange(): void {
    const oib = this.prijavnicaForm.get('predlagOib')?.value;

    if (oib && oib.length === 11) {
      // Pozivanje servisa za godinu donacije
      this.postsService
        .getGodineDonacija(oib, this.postsService.natjecaj.godina!, 5)
        .subscribe({
          next: (res) => {
            const god = res;
            this.prijavnicaForm.patchValue({ predlagGodDonacija: god });
          },
          error: (err) => console.error('Error:', err),
        });

      // Pozivanje servisa za OIB podatke
      this.postsService.getOibData(oib).subscribe({
        next: (data) => {
          const details = data.pravnaOsoba.pravnaOsoba.dohvatiPE;
          this.prijavnicaForm.patchValue({
            predlagNaziv: details.nazivTvrtke,
            predlagUlica:
              details.adresaSjedista.ulica +
              ' ' +
              details.adresaSjedista.kucniBroj,
            predlagPtBr: details.adresaSjedista.brojPoste,
            predlagGrad: details.adresaSjedista.naselje,
          });
          this.updateCharacterCount();
        },
        error: (err) =>
          console.error('Greška prilikom dohvaćanja podataka:', err),
      });
    } else {
      this.prijavnicaForm.patchValue({
        predlagNaziv: '',
        predlagUlica: '',
        predlagPtBr: '',
        predlagGrad: '',
      });
    }
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === '.' || event.key === ',') {
      event.preventDefault(); // Sprečava unos decimalne točke ili zareza
    }
  }

  blockInvalidCharacters(event: KeyboardEvent): void {
    const key = event.key;

    // Ako je pritisnut Ctrl (ili Cmd na Macu), ne blokiraj ništa
    if (event.ctrlKey || event.metaKey) {
      return;
    }

    const isNumber = /^[0-9]$/.test(key);
    const isControlKey =
      key === 'Backspace' ||
      key === 'ArrowLeft' ||
      key === 'ArrowRight' ||
      key === 'Delete' ||
      key === 'Tab';

    if (!isNumber && !isControlKey) {
      event.preventDefault();
    }
  }
  blockInvalidCharactersPnb(event: KeyboardEvent): void {
    const allowedKeys = [
      'Backspace',
      'Tab',
      'ArrowLeft',
      'ArrowRight',
      'Delete',
      'Home',
      'End',
    ];
    const allowedPattern = /^[0-9-]$/; // samo brojke i crtica

    // dopusti navigacijske tipke
    if (allowedKeys.includes(event.key)) return;

    // ako znak nije broj ni crtica → blokiraj
    if (!allowedPattern.test(event.key)) {
      event.preventDefault();
      return;
    }

    // ako korisnik pokušava unijeti treću crticu → blokiraj
    const input = event.target as HTMLInputElement;
    if (event.key === '-' && (input.value.match(/-/g)?.length || 0) >= 2) {
      event.preventDefault();
    }
  }

  onPasteOib(event: ClipboardEvent): void {
    const pastedText = event.clipboardData?.getData('text') || '';

    // Ako zalijepljeni tekst sadrži išta osim brojeva – spriječi lijepljenje
    if (!/^\d+$/.test(pastedText)) {
      event.preventDefault();
    }
  }

  blockInvalidCharactersBrojevi(event: KeyboardEvent): void {
    const allowedKeys = [
      'Backspace',
      'Tab',
      'ArrowLeft',
      'ArrowRight',
      'Delete',
    ]; // Dozvoljene specijalne tipke
    const nonNumberRegex = /^[^\d]$/; // Regex za nebrojčane znakove (bilo koji znak osim brojeva)

    // Provjera: dozvoljeni specijalni tasteri ili nebrojčani znakovi
    if (!allowedKeys.includes(event.key) && !nonNumberRegex.test(event.key)) {
      event.preventDefault(); // Blokiraj unos brojeva
    }
  }

  blockInvalidCharactersSlova(event: KeyboardEvent): void {
    const allowedKeys = [
      'Backspace',
      'Tab',
      'ArrowLeft',
      'ArrowRight',
      'Delete',
      ',',
      '.'    
    ];
    const numberRegex = /^[0-9]$/;

    // Provjera: dozvoljeni specijalni tasteri ili brojevi
    if (!allowedKeys.includes(event.key) && !numberRegex.test(event.key)) {
      event.preventDefault(); // Blokiraj unos
    }
  }



  klik1: boolean = false;
  klik2: boolean = false;
  klik3: boolean = false;
  klik4: boolean = false;
  klik5: boolean = false;
  // // Simulira klik na skriveni input
  triggerFileInput1(): void {
    this.fileInput1.nativeElement.click();
  }
  triggerFileInput2(): void {
    this.fileInput2.nativeElement.click();
  }

  triggerFileInput3(): void {
    this.fileInput3.nativeElement.click();
  }
  triggerFileInput4(): void {
    this.fileInput4.nativeElement.click();
  }
  triggerFileInput5(): void {
    this.fileInput5.nativeElement.click();
  }
  triggerFileInput6(): void {
    this.fileInput6.nativeElement.click();
  }
  triggerFileInput7(): void {
    this.fileInput7.nativeElement.click();
  }

  // Sprema odabrane datoteke
  onFileSelected(event: Event, controlName: string): void {
    const input = event.target as HTMLInputElement;
    const files = input.files;

    if (files && files.length > 0 && controlName == 'obrazacProracuna') {
      this.klik1 = false;
      this.selectedFile1 = files[0]; // Dozvoli samo jednu datoteku
      this.validationMessages1 = [];
      this.validateFile(event, this.validationMessages1);
      this.prijavnicaFormFile.get(controlName)?.setValue(this.selectedFile1);
      this.prijavnicaFormFile.patchValue({
        obrazacProracuna: this.selectedFile1,
      });
    } else if (
      (files == null || files.length == 0) &&
      controlName == 'obrazacProracuna'
    ) {
      this.klik1 = true;
    }

    if (files && files.length > 0 && controlName == 'dokazRegistarNadl') {
      this.klik2 = false;
      this.selectedFile2 = files[0]; // Dozvoli samo jednu datoteku
      this.validationMessages2 = [];
      this.validateFile(event, this.validationMessages2);
      this.prijavnicaFormFile.get(controlName)?.setValue(this.selectedFile2);

      this.prijavnicaFormFile.patchValue({
        dokazRegistarNadl: this.selectedFile2,
      });
    } else if (
      (files == null || files.length == 0) &&
      controlName == 'dokazRegistarNadl'
    ) {
      this.klik2 = true;
    }

    if (files && files.length > 0 && controlName == 'potvrdaPorezna') {
      this.klik3 = false;
      this.selectedFile3 = files[0]; // Dozvoli samo jednu datoteku
      this.validationMessages3 = [];
      this.validateFile(event, this.validationMessages3);
      this.prijavnicaFormFile.get(controlName)?.setValue(this.selectedFile3);

      this.prijavnicaFormFile.patchValue({
        potvrdaPorezna: this.selectedFile3,
      });
    } else if (
      (files == null || files.length == 0) &&
      controlName == 'potvrdaPorezna'
    ) {
      this.klik3 = true;
    }

    if (files && files.length > 0 && controlName == 'uvjerenjeNekaz') {
      this.klik4 = false;
      this.selectedFile4 = files[0]; // Dozvoli samo jednu datoteku
      this.validationMessages4 = [];
      this.validateFile(event, this.validationMessages4);
      this.prijavnicaFormFile.get(controlName)?.setValue(this.selectedFile4);

      this.prijavnicaFormFile.patchValue({
        uvjerenjeNekaz: this.selectedFile4,
      });
    } else if (
      (files == null || files.length == 0) &&
      controlName == 'uvjerenjeNekaz'
    ) {
      this.klik4 = true;
    }

    if (files && files.length > 0 && controlName == 'izjavaOsnova') {
      this.klik5 = false;
      this.selectedFile5 = files[0]; // Dozvoli samo jednu datoteku
      this.validationMessages5 = [];
      this.validateFile(event, this.validationMessages5);
      this.prijavnicaFormFile.get(controlName)?.setValue(this.selectedFile5);

      this.prijavnicaFormFile.patchValue({
        izjavaOsnova: this.selectedFile5,
      });
    } else if (
      (files == null || files.length == 0) &&
      controlName == 'izjavaOsnova'
    ) {
      this.klik5 = true;
    }
    //ove nisu obvezne:

    if (files && files.length > 0 && controlName == 'dokazRegistarNeprofit') {
      this.selectedFile6 = files[0]; // Dozvoli samo jednu datoteku
      this.validationMessages6 = [];
      this.validateFile(event, this.validationMessages6);
      this.prijavnicaFormFile.get(controlName)?.setValue(this.selectedFile6);

      this.prijavnicaFormFile.patchValue({
        dokazRegistarNeprofit: this.selectedFile6,
      });
    }

    if (files && files.length > 0 && controlName == 'dokumentiOstalo') {
      this.selectedFile7 = files[0]; // Dozvoli samo jednu datoteku
      this.validationMessages7 = [];
      this.validateFile(event, this.validationMessages7);
      this.prijavnicaFormFile.get(controlName)?.setValue(this.selectedFile7);

      this.prijavnicaFormFile.patchValue({
        dokumentiOstalo: this.selectedFile7,
      });
    }

    input.value = '';
  }

  removeFile(controlName: string): void {
    if (controlName == 'obrazacProracuna') {
      this.selectedFile1 = null;
      this.validationMessages1 = [];
      this.prijavnicaFormFile.get('obrazacProracuna')?.setValue(null);

      this.klik1 = true;
    }
    if (controlName == 'dokazRegistarNadl') {
      this.selectedFile2 = null;
      this.validationMessages2 = [];
      this.prijavnicaFormFile.get('dokazRegistarNadl')?.setValue(null);

      this.klik2 = true;
    }
    if (controlName == 'potvrdaPorezna') {
      this.selectedFile3 = null;
      this.validationMessages3 = [];
      this.prijavnicaFormFile.get('potvrdaPorezna')?.setValue(null);

      this.klik3 = true;
    }
    if (controlName == 'uvjerenjeNekaz') {
      this.selectedFile4 = null;
      this.validationMessages4 = [];
      this.prijavnicaFormFile.get('uvjerenjeNekaz')?.setValue(null);

      this.klik4 = true;
    }
    if (controlName == 'izjavaOsnova') {
      this.selectedFile5 = null;
      this.validationMessages5 = [];
      this.prijavnicaFormFile.get('izjavaOsnova')?.setValue(null);

      this.klik5 = true;
    }

    if (controlName == 'dokazRegistarNeprofit') {
      this.selectedFile6 = null;
      this.validationMessages6 = [];
      this.prijavnicaFormFile.get('dokazRegistarNeprofit')?.setValue(null);
    }

    if (controlName == 'dokumentiOstalo') {
      this.selectedFile7 = null;
      this.validationMessages7 = [];
      this.prijavnicaFormFile.get('dokumentiOstalo')?.setValue(null);
    }
    // dokazRegistarNeprofit
  }

  maxFileSize = 10 * 1024 * 1024; // 10 MB
  minFileSize = 1; // minimalno 1 bajt (0 nije dopušten)

  validationMessages1: string[] = [];
  validationMessages2: string[] = [];
  validationMessages3: string[] = [];
  validationMessages4: string[] = [];
  validationMessages5: string[] = [];
  validationMessages6: string[] = [];
  validationMessages7: string[] = [];

  // Dopušteni formati
  allowedExtensions = ['pdf', 'jpg', 'jpeg', 'png', 'docx', 'zip'];
  allowedMimeTypes = [
    'application/pdf',
    'image/jpeg',
    'image/png',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/zip', // ZIP standard
    'application/x-zip-compressed', // ZIP varijanta (Windows servers)
  ];
  private validateFile(event: any, messages: string[]) {
    const files: FileList = event.target.files;

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const extension = file.name.split('.').pop()?.toLowerCase();
      const mimeType = file.type;

      // Provjera po ekstenziji
      if (!extension || !this.allowedExtensions.includes(extension)) {
        messages.push(
          ` "${file.name}" nije dopuštenog formata (pdf, jpg, png, docx, zip).`,
        );
        continue;
      }

      // Provjera po MIME tipu
      if (!this.allowedMimeTypes.includes(mimeType)) {
        messages.push(
          ` "${file.name}" ima neispravan MIME type (${mimeType}).`,
        );
        continue;
      }

      // 2) Minimalna veličina
      if (file.size < this.minFileSize) {
        messages.push(` "${file.name}" - je prazna ili oštećena (0 B).`);
      }

      // 3) Maksimalna veličina
      if (file.size > this.maxFileSize) {
        messages.push(
          ` "${file.name}" je prevelika. Maksimalna veličina je ${
            this.maxFileSize / 1024 / 1024
          } MB.`,
        );
      }
    }
  }

  ////NOVO S DOKUMENTIMA
  //selectedFile: File | null = null; // za obrazac proračuna

  // onFileSelected(event: Event, controlName: string) {
  //   const input = event.target as HTMLInputElement;
  //   if (!input.files || input.files.length === 0) return;

  //   const file = input.files[0];

  //   switch (controlName) {
  //     case 'obrazacProracuna':
  //       this.selectedFile1 = file;
  //       break;
  //     case 'dokazRegistarNadl':
  //       this.selectedFile2 = file;
  //       break;
  //     case 'dokazRegistarNeprofit':
  //       this.selectedFile3 = file;
  //       break;
  //     case 'dokumentiOstalo':
  //       this.selectedFile4 = file;
  //       break;
  //   }

  //   // opcionalno: odmah validacija
  //   this.validateFile(event, controlName);
  // }

  //////////////

  // resetFileInput(controlName: string): void {
  //   const control = this.prijavnicaFormFile.get(controlName);
  //   if (control) {
  //     control.reset(); // Resetira stanje kontrole
  //   }
  //   this.fileInput1.nativeElement.value = ''; // Resetiraj fizički input element
  // }

  isFieldRequired(controlName: string): boolean {
    const control = this.prijavnicaForm.get(controlName);
    if (!control || !control.validator) {
      return false;
    }
    const validator = control.validator({} as AbstractControl);
    return validator && validator['required'];
  }
  isFieldRequiredpr(controlName: string): boolean {
    const control = this.prijavnicaFormFile.get(controlName);
    if (!control || !control.validator) {
      return false;
    }
    const validator = control.validator({} as AbstractControl);
    return validator && validator['required'];
  }

  async nextStep() {
    let fieldToFocus: any;
    // this.prijavnicaForm.markAllAsTouched();
    if ([0, 1].includes(this.currentStep)) {
      const requiredFields0 = ['idPodr'];
      let hasErrors0 = false;
      const listaIdPodr = this.podrucjaPrijave.map((p) => p.idPodr);
      // requiredFields0.forEach((field) => {
      const control = this.prijavnicaForm.get('idPodr');
      if (!listaIdPodr.includes(control?.value)) {
        //
        hasErrors0 = true;
        this.podrPrijaveError = '';
      }
      // });

      if (!hasErrors0) {
        // Ako nema grešaka, prelazite na sljedeći korak
        this.currentStep++;
      } else {
        this.podrPrijaveError = 'Molimo popunite područje prijave';
        //'Područje prijave mora biti popunjeno!'
        //  console.log('Popunite obvezna polja.');
      }
    } else if (this.currentStep === 2) {
      const requiredFields = [
        'predlagOib',
        'predlagMatReg',
        'predlagNaziv',
        'predlagGrad',
        'predlagPtBr',
        'predlagUlica',
        'predlagZupanijaId',
        'predlagZupanija',
        'predlagIban',
        'predlagBanka',
        'predlagOvlOs',
        'predlagFjaOvlOs',
        'predlagTel',
        'predlagGodOsnut',
        'predlagBrZaposleni',
        'predlagBrOsobaNak',
        'predlagBrVolonteri',
        'predlagPrihodi',
        'predlagCiljOsnivanja',
      ];

      let hasErrors = false;
      requiredFields.forEach((field) => {
        const control = this.prijavnicaForm.get(field);
        if (control && !control.valid) {
          if (!fieldToFocus) {
            fieldToFocus = field;
          }
          control.markAsTouched(); // Označi kao "touched" samo ako je nevažeće
          hasErrors = true;

          if (!this.prijavnicaForm) {
            console.warn(' NEXT STEP Forma još nije inicijalizirana!');
          } else {
            console.log(this.prijavnicaForm?.get('predlagOib')?.errors);
          }
        }
      });

      // ⚠️ Ako je forma PENDING, čekamo njen konačni status
      if (this.prijavnicaForm.pending) {
        console.log('Čekam završetak async validacije...');
        await this.prijavnicaForm.statusChanges
          .pipe(
            filter((status) => status !== 'PENDING'), // Čekaj da ne bude PENDING
            take(1), // Uzmi samo jednu promjenu statusa
          )
          .toPromise();
      }

      //await new Promise(resolve => setTimeout(resolve, 500)); // Kratki delay

      if (hasErrors === false) {
        // Ako nema grešaka, prelazite na sljedeći korak
        // console.log('⚠️ NEXT STEP FORMA VALIDNA.');

        if (this.prijavnicaForm.pending) {
          console.log('Forma još uvijek čeka validaciju...');
          return;
        }

        this.currentStep++;
      } else {
        console.log('Popunite obvezna polja.');
        var element = document.getElementById(fieldToFocus);
        element?.focus();
      }
    } else if (this.currentStep === 3) {
      const requiredFields3 = [
        'projektNaziv',
        'projektOpis',
        'projektIznos',
        'projektCilj',
        'projektGeoPodr',
        'projektSredstva',
        'projektIznosHep',
        'projektProblem',
        'projektRezultati',
        'projektAktivnosti',
        'projektKorisnici',
        'projektPracenje',
        'projektOdgOs',
      ];
      let hasErrors3 = false;
      requiredFields3.forEach((field) => {
        const control = this.prijavnicaForm.get(field);
        if (control && !control.valid) {
          if (!fieldToFocus) {
            fieldToFocus = field;
          }
          control.markAsTouched(); // Označi kao "touched" samo ako je nevažeće
          hasErrors3 = true;
        }
      });

      if (!hasErrors3) {
        // Ako nema grešaka, prelazite na sljedeći korak
        this.currentStep++;
      } else {
        console.log('Popunite obvezna polja.');
        var element = document.getElementById(fieldToFocus);
        element?.focus();
      }
    } else if (this.currentStep === 4) {
      const requiredFields4 = [
        // 'predlagodgNaziv',
        // 'predlagodgAdresa',
        // 'predlagodgPtBr',
        'predlagodgTel',
        //  'predlagodgGrad',
        'predlagodgKontaktOs',
        'predlagodgEmail',
      ];
      let hasErrors4 = false;
      requiredFields4.forEach((field) => {
        const control = this.prijavnicaForm.get(field);
        if (control && !control.valid) {
          if (!fieldToFocus) {
            fieldToFocus = field;
          }
          control.markAsTouched(); // Označi kao "touched" samo ako je nevažeće
          hasErrors4 = true;
        }
      });

      if (!hasErrors4) {
        // Ako nema grešaka, prelazite na sljedeći korak
        this.currentStep++;
      } else {
        console.log('Popunite obvezna polja.');
        var element = document.getElementById(fieldToFocus);
        element?.focus();
      }
    } else if (this.currentStep === 5) {
      const requiredFields5 = [
        'obrazacProracuna',
        'dokazRegistarNadl',
        'potvrdaPorezna',
        'uvjerenjeNekaz',
        'izjavaOsnova',
      ];
      let hasErrors5 = false;
      let hasErrors5FileType = false;
      requiredFields5.forEach((field) => {
        const control = this.prijavnicaFormFile.get(field);
        if (control && !control.valid) {
          if (!fieldToFocus) {
            fieldToFocus = field;
          }
          control.markAsTouched(); // Označi kao "touched" samo ako je nevažeće
          hasErrors5 = true;

          if (field == 'obrazacProracuna') {
            this.klik1 = true;
          }
          if (field == 'dokazRegistarNadl') {
            this.klik2 = true;
          }
          if (field == 'potvrdaPorezna') {
            this.klik3 = true;
          }
          if (field == 'uvjerenjeNekaz') {
            this.klik4 = true;
          }
          if (field == 'dokazRegistarNadl') {
            this.klik5 = true;
          }
          this.showModal = false;
        }
      });

      if (
        this.validationMessages1.length ||
        this.validationMessages2.length ||
        this.validationMessages3.length ||
        this.validationMessages4.length ||
        this.validationMessages5.length ||
        this.validationMessages6.length ||
        this.validationMessages7.length
      ) {
        if (this.validationMessages1.length) {
          hasErrors5FileType = true;
          fieldToFocus = 'hiddenFileInput1F';
        }

        if (this.validationMessages2.length) {
          hasErrors5FileType = true;
          fieldToFocus = 'hiddenFileInput2F';
        }

        if (this.validationMessages3.length) {
          hasErrors5FileType = true;
          fieldToFocus = 'hiddenFileInput3F';
        }

        if (this.validationMessages4.length) {
          hasErrors5FileType = true;
          fieldToFocus = 'hiddenFileInput4F';
        }
        if (this.validationMessages5.length) {
          hasErrors5FileType = true;
          fieldToFocus = 'hiddenFileInput5F';
        }
      } else {
        this.showModal = true;
        hasErrors5FileType = false;
      }

      if (!hasErrors5 && !hasErrors5FileType) {
        // Ako nema grešaka, prelazite na sljedeći korak
        this.showModal = true;
        // const modal = new bootstrap.Modal(this.exampleModal.nativeElement);
        // modal.show();
      } else {
        console.log('Popunite obvezna polja.');
        var element = document.getElementById(fieldToFocus);
        element?.focus();
        // this.klikO=true;
        this.showModal = false;
      }
    }
  }

  reqFieldsStep1 = ['idPodr'];
  reqFieldsStep2 = [
    'predlagOib',
    'predlagMatReg',
    'predlagNaziv',
    'predlagGrad',
    'predlagPtBr',
    'predlagUlica',
    'predlagZupanijaId',
    'predlagZupanija',
    'predlagIban',
    'predlagBanka',
    'predlagOvlOs',
    'predlagFjaOvlOs',
    'predlagTel',
    'predlagGodOsnut',
    'predlagBrZaposleni',
    'predlagBrOsobaNak',
    'predlagBrVolonteri',
    'predlagPrihodi',
    'predlagCiljOsnivanja',
  ];
  reqFieldsStep3 = [
    'projektNaziv',
    'projektOpis',
    'projektIznos',
    'projektCilj',
    'projektGeoPodr',
    'projektSredstva',
    'projektIznosHep',
    'projektProblem',
    'projektRezultati',
    'projektAktivnosti',
    'projektKorisnici',
    'projektPracenje',
    'projektOdgOs',
  ];

  reqFieldsStep4 = [
    'predlagodgNaziv',
    'predlagodgAdresa',
    'predlagodgPtBr',
    'predlagodgTel',
    'predlagodgGrad',
    'predlagodgKontaktOs',
    'predlagodgEmail',
  ];

  requiredFieldsList = [
    this.reqFieldsStep1,
    this.reqFieldsStep2,
    this.reqFieldsStep3,
    this.reqFieldsStep4,
  ];

  // step su brojevi od 1-5, ali npr step 1 validiramo kad kliknemo na broj 2, step 1 i 2 ćemo validirati kad kliknemo na broj 3 itd.
  validirajStep(step: number): boolean {
    let hasErrors = false;
    let isOk = true;

    this.requiredFieldsList[step - 1].forEach((field) => {
      const control = this.prijavnicaForm.get(field);

      if (control && !control.valid) {
        control.markAsTouched(); // Označi kao "touched", ali ne forsira fokus
        hasErrors = true;
        isOk = false;
        console.log(`Polje ${field} nije validno.`);
      }
    });

    if (hasErrors) {
      console.log('Popunite obvezna polja.');
    }

    return isOk;
  }

  // Funkcija za povratak na prethodnu stranicu
  previousStep(): void {
    if (this.currentStep > 1) {
      this.currentStep--;
    }
  }

  limitInputLength(event: Event, maxLength: number): void {
    const input = event.target as HTMLInputElement;
    if (input.value.length > maxLength) {
      input.value = input.value.slice(0, maxLength); // Skrati unos na maksimalnu duljinu
    }
  }

  loading = false;

  openPreview() {
    // if (this.prijavnicaForm.valid) {
    this.showModal = true; // Prikazuje modal
  }

  closePreview() {
    this.showModal = false; // Zatvara modal
  }
  formatNumberToService(value: string): string {
    if (!value) return '';
    // Zamjena točke s ništa i zareza s točkom
    return value.replace(/\./g, '').replace(',', '.');
  }

  formatNumber(amount: number): string {
    return amount.toLocaleString('hr-HR', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
  formatNumberInput(event: any) {
    let inputElement = event.target;
    let value = inputElement.value;

    // Ukloni sve znakove osim brojeva i zareza
    value = value.replace(/[^0-9,]/g, '');

    // Spriječi unos više od jednog zareza
    let parts = value.split(',');
    if (parts.length > 2) {
      parts = [parts[0], parts.slice(1).join('')]; // Spoji sve nakon prvog zareza
    }

    // Formatiraj broj sa separatorima tisućica
    let integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'); // Dodaj točke za tisuće
    let decimalPart = parts[1] ? ',' + parts[1].substring(0, 2) : ''; // Maksimalno 2 decimalna mjesta

    // Postavi vrijednost natrag u input polje
    inputElement.value = integerPart + decimalPart;
  }

  podrPrijaveError: string = '';

  onRadioChange(selectedIdPodr: number): void {
    this.podrPrijaveError = '';
    this.selectedPodrucjeId = selectedIdPodr;
     this.postsService.podrucjeNaziv = this.getNazivPodrucja(selectedIdPodr);

    this.prijavnicaForm.patchValue({
      idPodr: this.selectedPodrucjeId,
      nazivPodr: this.postsService.podrucjeNaziv,
    });
  }

  openConfirmModal() {
    if (this.userInput.trim() === '') {
      this.captchaError = true;
      this.emptyCaptchaError = true;
      this.isCaptchaValid = false;
      this.cdr.detectChanges();
    } else if (!this.isCaptchaValid) {
      this.captchaError = true;
      this.emptyCaptchaError = false;
      this.cdr.detectChanges();
    } else {
      const modalElement = document.getElementById('exampleModal');
      if (modalElement) {
        new (window as any).bootstrap.Modal(modalElement).show();
      }
    }
  }
  isLoading: boolean = false; // Dodaj ovu varijablu u klasu
  emptyCaptchaError = false;

  ////SUBMIT
  onSubmit(): void {
    this.isLoading = true; // Pokreni spinner
    this.captchaError = false;
    this.emptyCaptchaError = false;
    this.cdr.detectChanges();
    const formData = new FormData();
    this.postsService.podrucjeNaziv = this.getNazivPodrucja(
      this.selectedPodrucjeId!,
    );

    this.selectedZupanija = this.getZupanijaNaziv(this.selectedZupanijaId!);

    this.novaPrijavnica = this.prijavnicaForm.value;
    this.prijavnicaForm.value['predlagPrihodi'] = Number(
      this.formatNumberToService(this.prijavnicaForm.value['predlagPrihodi']),
    );
    // this.novaPrijavnica = this.prijavnicaForm.value;

    /////////////
    this.prijavnicaForm.value['projektIznos'] = Number(
      this.formatNumberToService(this.prijavnicaForm.value['projektIznos']),
    );
    this.prijavnicaForm.value['projektIznosHep'] = Number(
      this.formatNumberToService(this.prijavnicaForm.value['projektIznosHep']),
    );
    this.prijavnicaForm.value['idNatjecaja'] =
      this.postsService.natjecaj.idNatjecaja;
    this.prijavnicaForm.value['nazivNatjecaja'] =
      this.postsService.natjecaj.naziv;
    this.prijavnicaForm.value['nazivPodr'] = this.postsService.podrucjeNaziv;
    this.prijavnicaForm.value['predlagZupanija'] = this.selectedZupanija;
    this.prijavnicaForm.value['godinaNatjecaja'] =
      this.postsService.natjecaj.godina;

    this.novaPrijavnica = this.prijavnicaForm.value;
    /////////////
    formData.append('prijavnica', JSON.stringify(this.novaPrijavnica));

    Object.keys(this.prijavnicaFormFile.value).forEach((key) => {
      formData.append(key, this.prijavnicaFormFile.value[key]);
    });



    const modalElement = document.getElementById('exampleModal');

    this.captchaError = false;
    this.emptyCaptchaError = false;

    this.postsService.spremiprijavnica(formData).subscribe({
      next: (response: any) => {
        this.handleResponse(response, modalElement);
        this.showModal = false;
        this.cdr.detectChanges();
      },
      error: (error: HttpErrorResponse) => {
        console.error('Greška pri slanju prijavnice:', error);
        this.navigateToError(modalElement);
        this.cdr.detectChanges();
      },
      complete: () => {
        console.log('Slanje prijavnice završeno.');
        this.isLoading = false; // Zaustavi spinner

        this.cdr.detectChanges();
      },
    });
  }

  private handleResponse(response: any, modalElement: HTMLElement | null) {
    if (response.status === 'EXISTS') {
      this.closeModalAndNavigate(modalElement, '/error');
    } else if (response.status === 'OK') {
      this.postsService.spremanjeStatus = response.status;
      this.postsService.spremanjePoruka = response.message;
      this.closeModalAndNavigate(modalElement, '/success');
    }
  }

  private navigateToError(modalElement: HTMLElement | null) {
    this.closeModal(modalElement);
    setTimeout(() => this.router.navigate(['/error']), 10);
    this.isLoading = false; // Zaustavi spinner na grešku
  }

  private closeModalAndNavigate(
    modalElement: HTMLElement | null,
    route: string,
  ) {
    this.closeModal(modalElement);
    setTimeout(() => this.router.navigate([route]), 10);
  }

  private closeModal(modalElement: HTMLElement | null) {
    if (modalElement) {
      modalElement.classList.remove('show');
      modalElement.setAttribute('aria-hidden', 'true');
      modalElement.style.display = 'none';
      document.body.classList.remove('modal-open');
      document.querySelector('.modal-backdrop')?.remove();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  onPaste(event: ClipboardEvent) {
    event.preventDefault(); // Sprječava zadano ponašanje (paste)

    const clipboardData = event.clipboardData?.getData('text').trim(); // Dohvaća tekst s clipboarda
    if (clipboardData && /^\d{11}$/.test(clipboardData)) {
      // Provjera da je OIB točan
      this.prijavnicaForm.patchValue({ predlagOib: clipboardData }); // Postavlja vrijednost u input
      this.onOibChange(); // Poziva onOibChange kako bi obradio podatke
    } else {
      alert('OIB mora imati točno 11 znamenki.');
    }
  }
}